import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { outputFromObservable } from '@angular/core/rxjs-interop';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { map } from 'rxjs/operators';
import { ShInputTextComponent, TextValueAccessor } from '@gbr-monorepo/gbr-shui';
import { GraphUserSearchQuery } from '@gbr-monorepo/interfaces';

@Component({
    selector: 'app-user-search-bar',
    templateUrl: 'user-search-bar.component.html',
    imports: [ShInputTextComponent, TextValueAccessor, ReactiveFormsModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserSearchBarComponent {
    public readonly firstNameLabel = input.required<string>();
    public readonly lastNameLabel = input.required<string>();
    public readonly gidLabel = input.required<string>();

    protected readonly searchFormGroup = new FormGroup({
        firstname: new FormControl(''),
        surname: new FormControl(''),
        employeeId: new FormControl('')
    });

    protected get firstNameControl(): FormControl<string | null> {
        return this.searchFormGroup.get('firstname') as FormControl<string | null>;
    }

    protected get surnameControl(): FormControl<string | null> {
        return this.searchFormGroup.get('surname') as FormControl<string | null>;
    }

    protected get employeeIdControl(): FormControl<string | null> {
        return this.searchFormGroup.get('employeeId') as FormControl<string | null>;
    }

    public readonly search = outputFromObservable<GraphUserSearchQuery | null>(
        this.searchFormGroup.valueChanges.pipe(
            distinctUntilChanged(),
            debounceTime(500),
            map(value => this.removeEmptySearchValues(value)),
            map(value => (Object.keys(value).length > 0 ? value : null))
        )
    );

    private removeEmptySearchValues(value: typeof this.searchFormGroup.value) {
        return Object.fromEntries(
            Object.entries(value)
                .map(([key, formValue]) => [key, formValue?.trim().toUpperCase()] as const)
                .filter(([, formValue]) => formValue)
        );
    }

    public clearSearch(): void {
        this.searchFormGroup.reset({ firstname: '', surname: '', employeeId: '' });
    }
}
